import {
  put,
  // select
} from 'redux-saga/effects';
import EasyRedux from '../../utils/EasyRedux';
import handleSagaError from '../handleSagaError';
import { setToken } from './token';
import { actions as profileActions } from './profile';
// import navigateAuthUser from '../../utils/navigateAuthUser';

const key = 'AUTH/SESSION';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchStartSession(client, store) {
  try {
    const data = {
      pl: 23,
      bl: 1,
      di: 'test',
      dn: 'Something',
      os: 'Web',
    };
    const response = yield client.post('/session/start', { data });
    yield put(setToken(response.result.session.token));
    yield put(profileActions.load());
    yield put(actions.loadSuccess(response.result));
    // const user = yield select((state) => state.login);
    // navigateAuthUser(user, store.dispatch);
  } catch (e) {
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
